import { render, staticRenderFns } from "./basketOfferDetails.vue?vue&type=template&id=195217d2&"
import script from "./basketOfferDetails.vue?vue&type=script&lang=js&"
export * from "./basketOfferDetails.vue?vue&type=script&lang=js&"
import style0 from "./basketOfferDetails.vue?vue&type=style&index=0&id=195217d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports